import { render, staticRenderFns } from "./HowBlockItem.vue?vue&type=template&id=78e83b08"
import script from "./HowBlockItem.vue?vue&type=script&lang=js"
export * from "./HowBlockItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports